import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Loader, Tab } from "semantic-ui-react";
import {} from "../../../config/functions";
import { selectTranslations } from "../../../config/i18n/slice";
import UserProfilePlaceholder from "../../../components/common/userProfilePlaceholder";
import { CommentIcon, LogTabIcon } from "../../../../Assets/Icons/svg";
import CommentTab from "./actibityTab/comments/commentTab";
import AllDetails from "./actibityTab/allDetails.js/allDetails";
import { toast } from "react-toastify";
import { uploadFile } from "../../../config/api/configApis";
import {
  addNewComment,
  getAllComments,
} from "../../../config/api/workOrderApis";
import Chat from "./actibityTab/chat/chat";
import useModuleFlag from "../../../../hooks/useModuleFlag";
import { LDCONSTANTS } from "../../../config/LDconstants";

const Comments = ({ data }) => {
  const t = useSelector(selectTranslations);
  const [comment, setComment] = useState("");
    const isChatEnabled = useModuleFlag(LDCONSTANTS.CHAT_SERVICE_ENABLED);

  const [attachments, setAttachments] = useState({
    image: [],
  });

  const [commentLoading, setCommentLoading] = useState(true);
  const [allComments, setAllComments] = useState("");
  const [commentPage, setCommentPage] = useState(1);
  const [commentTotal, setCommentTotal] = useState();

  const onFileChange = async (files, name) => {
    let newFiles = [];
    Array.from(files).forEach((file) => {
      const randomnumber = Math.floor(Math.random() * 100);
      newFiles.push({
        file: file,
        id: randomnumber,
        name: file.name,
        type: file.type,
        cancelPopup: false,
        isChanged: true,
        previewUrl: URL.createObjectURL(file),
        isUploading: true,
        url: null,
      });
    });

    setAttachments((prevAttachments) => ({
      ...prevAttachments,
      [name]: [...(prevAttachments[name] || []), ...newFiles], // Keep previous files
    }));

    const uploadedFiles = await Promise.all(
      newFiles.map(async (fileObj) => {
        try {
          const formData = new FormData();
          formData.append("file", fileObj.file); // Assuming API expects a "file" field

          const uploadResponse = await uploadFile(formData); // Replace `uploadFile` with your actual API function

          if (uploadResponse?.status === 200) {
            return {
              ...fileObj,
              url: uploadResponse.data[0]?.url || null, // Add the uploaded URL
              fileID: uploadResponse.data[0]?.id || null, // Add the uploaded URL
              isUploading: false, // Upload completed
            };
          } else {
            toast.error(t.common.something_wrong);
            return { ...fileObj, isUploading: false };
          }
        } catch (error) {
          toast.error(t.common.something_wrong);
          return { ...fileObj, isUploading: false };
        }
      })
    );

    // Update the attachments state with the uploaded URLs
    setAttachments((prevAttachments) => ({
      ...prevAttachments,
      [name]: prevAttachments[name].map((file) =>
        file.isUploading
          ? uploadedFiles.find((f) => f.id === file.id) || file
          : file
      ),
    }));
  };

  const addComment = async () => {
    const fileIDs = attachments?.image
      ?.filter((attachment) => attachment?.fileID)
      ?.map((attachment) => attachment.fileID);

    const response = await addNewComment(data?.id, comment, fileIDs);

    if (response && response.status === 200) {
      toast.success(t.workOrders.activityTab.commentSuccess);
      setComment("");
      setCommentPage(1);
      if (commentPage === 1) {
        fetchAllComments();
      }
      setAttachments({
        image: [],
      });
    } else {
      toast.error(t.common.something_wrong);
    }
  };

  const handleRemoveAttachment = (id) => {
    const updatedAttachments = attachments?.image?.filter(
      (attachment) => attachment?.id !== id
    );

    setAttachments((prev) => {
      return {
        ...prev,
        image: updatedAttachments,
      };
    });
  };

  const fetchAllComments = async () => {
    setCommentLoading(true);
    const response = await getAllComments(data?.id, commentPage);

    if (response && response?.status === 200) {
      setAllComments(response?.response);
      setCommentTotal(response?.pagination?.total);
      setCommentPage(response?.pagination?.page);
    } else if (response.status == 400) {
      if (response?.error && response?.error?.message) {
        toast.error(response.error.message);
      }
    } else {
      toast.error(t.common.something_wrong);
    }
    setCommentLoading(false);
  };

  useEffect(() => {
    fetchAllComments();
  }, [commentPage]);

  const panes = [
   (!isChatEnabled || allComments?.length > 0 &&
    (data?.attributes?.status === "open" ||
      data?.attributes?.status === "completed"))
      ? {
          menuItem: {
            key: "comment",
            icon: <CommentIcon />,
            content: t.workOrders.details_view.comments,
          },
          pane: {
            key: "comment",
            content: (
              <CommentTab
                page={commentPage}
                allComments={allComments}
                setAllComments={setAllComments}
                setPage={setCommentPage}
                total={commentTotal}
                setTotal={setCommentTotal}
                setLoading={setCommentLoading}
                loading={commentLoading}
                fetchAllComments={fetchAllComments}
                addComment={addComment}
                comment={comment}
                setComment={setComment}
                attachments={attachments}
                setAttachments={setAttachments}
                onFileChange={onFileChange}
                handleRemoveAttachment={handleRemoveAttachment}
                data={data}
              />
            ),
          },
        }
      : {
          menuItem: {
            key: "logs",
            icon: <CommentIcon />,
            content: t.workOrders.activityTab.chat,
          },
          pane: {
            key: "logs",
            content: <Chat workOrderData={data} />,
          },
        },
  ];

  return (
    <>
     
      {commentLoading && (
        <Loader active inline="centered">
          {t.common.loading}
        </Loader>
      )}
      {!commentLoading && panes.length > 0 && (
        <Tab className="comments-tab" panes={panes} renderActiveOnly={false} />
      )}
    </>
  );
};
export default Comments;
